/**
 * opora-calc-runs.js — Live run counts for browser calculators.
 */
(function (global) {
  'use strict';

  var API = (global.OPORA_WORKER_URL || (global.OporaEdge && global.OporaEdge.WORKER_URL) || 'https://opora-ai.mshabliy.workers.dev').replace(/\/$/, '');
  var FALLBACK = (global.OPORA_WORKER_URL_FALLBACK || API).replace(/\/$/, '');
  var cache = {};

  function uuid() {
    try {
      var k = '_opora_uuid';
      var id = localStorage.getItem(k);
      if (!id) {
        id = global.crypto && global.crypto.randomUUID
          ? global.crypto.randomUUID()
          : 'u-' + Date.now() + '-' + Math.random().toString(16).slice(2);
        localStorage.setItem(k, id);
      }
      return id;
    } catch (e) {
      return 'anon';
    }
  }

  function formatCount(n) {
    if (n == null || isNaN(n)) return '—';
    n = Math.max(0, Math.floor(Number(n)));
    if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M+';
    if (n >= 10000) return Math.floor(n / 1000) + 'K+';
    return n.toLocaleString('en-US');
  }

  function parseCount(data) {
    if (!data || typeof data !== 'object') return null;
    if (data.count != null) return Number(data.count);
    if (data.runs != null) return Number(data.runs);
    if (data.total != null) return Number(data.total);
    if (data.run_count != null) return Number(data.run_count);
    return null;
  }

  function getJson(url) {
    return fetch(url, { credentials: 'omit', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function fetchCount(slug, cb) {
    if (cache[slug] != null) {
      cb(cache[slug]);
      return;
    }
    getJson(API + '/api/tools/' + encodeURIComponent(slug) + '/run-count').then(function (d) {
      var n = parseCount(d);
      if (n != null) { cache[slug] = n; cb(n); return; }
      return getJson(FALLBACK + '/api/tools/' + encodeURIComponent(slug) + '/run-count');
    }).then(function (d) {
      if (cache[slug] != null) return;
      var n = d ? parseCount(d) : null;
      if (n != null) cache[slug] = n;
      cb(cache[slug] != null ? cache[slug] : null);
    });
  }

  function record(slug, cb) {
    var headers = { 'Content-Type': 'application/json', 'X-Opora-UUID': uuid() };
    var body = JSON.stringify({
      tool_slug: slug,
      source: 'calc',
      page: global.location.pathname
    });

    if (typeof global.oporaTrack === 'function') {
      global.oporaTrack('calc_run', { tool_id: slug });
    }
    if (typeof global.oporaTrackToolRun === 'function') {
      global.oporaTrackToolRun(slug);
    }

    function done(data) {
      var n = data ? parseCount(data) : null;
      if (n != null) {
        cache[slug] = n;
        if (cb) cb(n);
      } else if (cache[slug] != null) {
        cache[slug]++;
        if (cb) cb(cache[slug]);
      } else if (cb) {
        fetchCount(slug, cb);
      }
    }

    fetch(API + '/api/tools/run', { method: 'POST', headers: headers, body: body, keepalive: true })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d) { done(d); return; }
        return fetch(FALLBACK + '/api/tools/run', { method: 'POST', headers: headers, body: body, keepalive: true })
          .then(function (r2) { return r2.ok ? r2.json() : null; });
      })
      .then(function (d2) { done(d2); })
      .catch(function () { done(null); });
  }

  // A single-digit run count reads as "nobody uses this" rather than as social proof,
  // so the counter stays hidden until the number is worth showing. Runs are still recorded.
  var MIN_DISPLAY = 500;

  function bindDisplay(slug, nodes) {
    if (!nodes || !nodes.length) return;
    fetchCount(slug, function (n) {
      var show = n != null && !isNaN(n) && Number(n) >= MIN_DISPLAY;
      var text = show ? formatCount(n) : '';
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].textContent = text;
        var card = nodes[i].closest ? nodes[i].closest('[data-calc-run-block]') : null;
        if (card) card.hidden = !show;
      }
    });
  }

  global.OporaCalcRuns = {
    fetchCount: fetchCount,
    record: record,
    bindDisplay: bindDisplay,
    formatCount: formatCount,
    MIN_DISPLAY: MIN_DISPLAY
  };
})(window);
